import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { NgxPermissionsService } from "ngx-permissions";
import { RedirectURLService } from '../auth/redirect-url.service'

import { LoginService } from './login.service';
import { Helpers } from "./helpers";
import { JwtHelper } from "./jwt-helper";

/**
 * Decides if a route can be activated.
 */
@Injectable()
export class AuthGuard implements CanActivate {

    //private permissionsService: NgxPermissionsService
    constructor(private loginService: LoginService, private router: Router, private permissionsService: NgxPermissionsService
        , private redirectURLService: RedirectURLService
    ) {

    }

    public canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
        // get logged in user
        const token: string = Helpers.getSessionStorage('id_token');
        if (token != null && token !=='') {

            let jwtHelper = new JwtHelper();

            try {
                let decodedIdToken = jwtHelper.decodeToken(token);

                this.permissionsService.flushPermissions();

                if (decodedIdToken != null) {
                    let userPermissions: Array<string> = [];

                    if (!!decodedIdToken.permission) {
                        if (decodedIdToken.permission.constructor != Array) {
                            userPermissions.push(decodedIdToken.permission);
                            // Store permissions in Permission Service
                            this.permissionsService.loadPermissions(userPermissions);
                        }
                        else {
                            // Store permissions in Permission Service
                            this.permissionsService.loadPermissions(decodedIdToken.permission);
                        }
                    }

                    return true;
                }
            }
            catch (err) {
            }            
        }

        // Stores the attempted URL for redirecting.
        const url: string = state.url;
        //this.loginService.redirectUrl = url;

        //// Not signed in so redirects to signin page.
        //this.router.navigate(['/auth/login']);

        // Not signed in so redirects to signin page.
        this.redirect(state.url);

        return false;
    }

    canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        // get logged in user
        const token: string = Helpers.getSessionStorage('id_token');
        if (token != null && token !== '') {

            let jwtHelper = new JwtHelper();

            try {
                let decodedIdToken = jwtHelper.decodeToken(token);

                if (decodedIdToken != null) {
                    let userPermissions: Array<string> = [];

                    if (!!decodedIdToken.permission) {
                        if (decodedIdToken.permission.constructor != Array) {
                            userPermissions.push(decodedIdToken.permission);
                            // Store permissions in Permission Service
                            this.permissionsService.loadPermissions(userPermissions);
                        }
                        else {
                            // Store permissions in Permission Service
                            this.permissionsService.loadPermissions(decodedIdToken.permission);
                        }
                    }

                    return true;
                }
            }
            catch (err) {
                this.redirect(this.router.url);
            }            
        }
        else {
            this.redirect(this.router.url);
        }

        return false;
    }

    private redirect(url: string) {
        try {
            this.redirectURLService.setData(url);
            this.router.navigate(['/auth/login']);
        }
        catch (err) {

        }        
    }
}